import { FC } from "react";

import { useScrollToHashOnFirstRender } from "shared/utils";

import { EditRegionalSettings } from "./containers";

export const EditRegionalSettingsPage: FC = () => {
  useScrollToHashOnFirstRender();

  return (
    <>
      <EditRegionalSettings />
    </>
  );
};
